import React from 'react'
import { useAuth } from '../../contexts/AuthContext'

const ServiceStatusBar = ({ status, isDarkMode, toggleDarkMode }) => {
    const { isAdmin } = useAuth()
    const devPortalUrl = status?.dev_portal_url || import.meta.env.VITE_DEV_PORTAL_URL;

    const textMuted  = isDarkMode ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.7)'
    const textHover  = isDarkMode ? '#25C6A4' : '#FFFFFF'
    const dividerCol = isDarkMode ? 'rgba(37,198,164,0.25)' : 'rgba(255,255,255,0.3)'

    return (
        <div
            className="h-10 flex items-center justify-between px-6"
            style={{
                backgroundColor: isDarkMode ? '#0A1C28' : '#25C6A4',
                borderBottom: isDarkMode ? '1px solid rgba(37,198,164,0.2)' : '1px solid rgba(0,0,0,0.08)',
                boxShadow: isDarkMode ? '0 2px 12px rgba(37,198,164,0.15)' : '0 2px 12px rgba(37,198,164,0.3)'
            }}
        >
            {/* Left: dev portal */}
            <div>
                {devPortalUrl && isAdmin && (
                    <a
                        href={devPortalUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-semibold transition-colors"
                        style={{
                            color: isDarkMode ? '#25C6A4' : '#FFFFFF',
                            backgroundColor: isDarkMode ? 'rgba(37,198,164,0.1)' : 'rgba(255,255,255,0.2)',
                            border: `1px solid ${isDarkMode ? 'rgba(37,198,164,0.3)' : 'rgba(255,255,255,0.4)'}`,
                        }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = isDarkMode ? 'rgba(37,198,164,0.2)' : 'rgba(255,255,255,0.3)'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = isDarkMode ? 'rgba(37,198,164,0.1)' : 'rgba(255,255,255,0.2)'}
                    >
                        <span className="material-icons" style={{ fontSize: '14px' }}>data_object</span>
                        Dev Portal
                    </a>
                )}
            </div>

            {/* Right: actions */}
            <div className="flex items-center gap-1">
                <div className="flex items-center gap-1.5 px-1" style={{ color: textMuted }}>
                    <span className="material-icons" style={{ fontSize: '14px' }}>verified</span>
                    <span className="text-xs font-mono font-medium tracking-wide">v1.0.0</span>
                </div>

                <div className="w-px h-4 mx-1" style={{ backgroundColor: dividerCol }} />

                <button
                    onClick={toggleDarkMode}
                    className="flex items-center justify-center w-8 h-8 rounded-md transition-colors"
                    style={{ color: textMuted }}
                    title={isDarkMode ? 'Modo claro' : 'Modo escuro'}
                    onMouseEnter={e => e.currentTarget.style.color = textHover}
                    onMouseLeave={e => e.currentTarget.style.color = textMuted}
                >
                    <span className="material-icons" style={{ fontSize: '16px' }}>
                        {isDarkMode ? 'light_mode' : 'dark_mode'}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default ServiceStatusBar
